export class ElementKeys {
  constructor(module, element) {
    this.module = module
    this.initElement(element)
    this.initModules()
  }
    
  initElement(element) {
    for (let property in element) {
      this[property] = element[property]
    }
  }

  initModules() {
    this.modules = {
      layoutPageComponentModule: {
        layoutPageComponent: this.layoutPageComponent
      },
      pageModule: {},
      pageComponentModule: {
        pageComponent: this.pageComponent,
      },
      sectionModule: {
        section: this.section,
      },
      rowModule: {
        section: this.section,
        row: this.row,
      },
      columnModule: {
        section: this.section,
        row: this.row,
        column: this.column,
      },
      componentModule: {
        section: this.section,
        row: this.row,
        column: this.column,
        component: this.component,
        pageComponent: this.pageComponent
      },
      componentSectionModule: {
        layoutPageComponent: this.layoutPageComponent,
        pageComponent: this.pageComponent,
        section: this.section,
        row: this.row,
        column: this.column,
        component: this.component,
        componentSection: this.componentSection,
      },
      componentRowModule: {
        layoutPageComponent: this.layoutPageComponent,
        pageComponent: this.pageComponent,
        section: this.section,
        row: this.row,
        column: this.column,
        component: this.component,
        componentSection: this.componentSection,
        componentRow: this.componentRow,
      },
      componentColumnModule: {
        layoutPageComponent: this.layoutPageComponent,
        pageComponent: this.pageComponent,
        section: this.section,
        row: this.row,
        column: this.column,
        component: this.component,
        componentSection: this.componentSection,
        componentRow: this.componentRow,
        componentColumn: this.componentColumn,
      },
      componentComponentModule: {
        layoutPageComponent: this.layoutPageComponent,
        pageComponent: this.pageComponent,
        section: this.section,
        row: this.row,
        column: this.column,
        component: this.component,
        componentSection: this.componentSection,
        componentRow: this.componentRow,
        componentColumn: this.componentColumn,
        componentComponent: this.componentComponent,
      },
      layoutRowModule: {
        section: this.section,
        row: this.row,
      },
      layoutColumnModule: {
        section: this.section,
        row: this.row,
        column: this.column,
      },
      layoutComponentModule: {
        section: this.section,
        row: this.row,
        column: this.column,
        component: this.component,
      },
    }
  }

  keys() {
    let element = this.modules[this.module]
    if (! element) {
      return element
    }
    Object.keys(element).forEach(key => element[key] === null || element[key] === undefined ? delete element[key] : null)
    return element
  }
}